<template>
    <DsTooltip
        v-if="tooltipText || $slots.tooltipContent"
        :tooltipLocation
        :tooltipText
    >
        <template
            v-if="$slots.tooltipContent"
            #content
        >
            <slot name="tooltipContent" />
        </template>
        <BadgeCore
            :icon
            :text
            :variant
        />
    </DsTooltip>
    <BadgeCore
        v-else
        :icon
        :text
        :variant
    />
</template>

<script setup lang="ts">
import BadgeCore, { type BadgeCoreProps } from '@/components/design-system/badge/BadgeCore.vue';
import DsTooltip from '@/components/design-system/tooltip/DsTooltip.vue';
import type { DsTooltipProps } from '@/components/design-system/tooltip/tooltip.types';

export interface DsBadgeProps extends BadgeCoreProps {
    tooltipText?: DsTooltipProps['tooltipText'];
    tooltipLocation?: DsTooltipProps['tooltipLocation'];
}

withDefaults(defineProps<DsBadgeProps>(), {
    tooltipLocation: 'top',
});

defineSlots<{
    tooltipContent: () => void;
}>();
</script>
